import { useImmer } from 'use-immer';
import { useCallback, useEffect, useRef } from 'react';
import debounce from 'lodash.debounce';

function useImmerDebounce(initialState, delay = 300) {
  const [state, setState] = useImmer(initialState);
  const debouncedSetState = useRef(null);

  useEffect(() => {
    debouncedSetState.current = debounce(setState, delay);

    return () => {
      debouncedSetState.current.cancel();
    };
  }, [delay]);

  const setDebouncedState = useCallback((updater) => {
    debouncedSetState.current(updater);
  }, []);

  return [state, setDebouncedState, setState];
}

export default useImmerDebounce;
